<template functional>
  <div v-if="props.features.length">
    <h3 class="text-xl text-primary">
      <slot />
    </h3>
    <div class="flex flex-row flex-wrap mt-20">
      <div
        v-for="(feature, index) in props.features"
        :key="`feature-${index}`"
        class="flex-shrink-0 w-full flex flex-row items-center pr-20 mb-12 tablet:w-1/2 laptop:w-1/3"
      >
        <div class="flex-shrink-0 h-44 w-44 flex items-center justify-center bg-primary rounded-full shadow-1dp">
          <FontAwesomeIcon
            :icon="feature.iconClassNames"
            fixed-width
            class="text-xl text-gray-50"
          />
        </div>
        <p class="leading-tight ml-15">{{ feature.label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    features: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
